export const FILTER_MISE_COHERENCE_TOUS = 1;
export const FILTER_MISE_COHERENCE_CENTRE_TRI = 2;
export const FILTER_MISE_COHERENCE_REPRENEUR = 3;
export const FILTER_MISE_COHERENCE_DIFFERENTE = 4;

export const FILTER_MISE_COHERENCE_TOUS_QUERY_VALUE = undefined;
export const FILTER_MISE_COHERENCE_CENTRE_TRI_QUERY_VALUE = null;
export const FILTER_MISE_COHERENCE_REPRENEUR_QUERY_VALUE = 1;
export const FILTER_MISE_COHERENCE_DIFFERENTE_QUERY_VALUE = 0;
